import { getDealerListApi } from '@/server'
import type { DealerParams, DealerResponse } from '@/server/types'
import { LOAD_STATE } from '~/shared/types'

export function logicDealerList() {
  const list = ref<DealerResponse[]>([])
  const state = ref(LOAD_STATE.INIT)
  async function getDealerList(params: DealerParams) {
    const res = await useLoadState({
      state,
      onlyClient: true,
      fn: () => getDealerListApi(params),
    })
    if (res)
      list.value = res.data
  }

  return {
    list,
    state,
    getDealerList,
  }
}
